/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-15 12:51:33
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-15 12:52:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileLibrary/config.ts
 */
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('settings.list.fileLibrary'),
  },
];
